import { render } from "./ListePaiementAutreRecette.vue?vue&type=template&id=1316c51c&ts=true"
import script from "./ListePaiementAutreRecette.vue?vue&type=script&lang=ts"
export * from "./ListePaiementAutreRecette.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__